import React from 'react';
import { hero } from '../assets/index.js';
import Typewriter from 'typewriter-effect';
import Tilt from 'react-parallax-tilt';
import { useTranslation } from 'react-i18next';
import withScrollReveal from '../animattion/withScrollReveal.jsx';

const Home = () => {
  const {t} = useTranslation();

  return (
    <div id='Home' className='h-auto md:h-[100vh] md:w-[100%] md:flex md:flex-wrap '>
      {/* left box */}
      <div className="h-[22rem] flex flex-wrap justify-start items-center md:h-full md:w-[50%] md:justify-center">
        <div>
          <p className='text-xl md:text-3xl' >{t('Home_txt1')}</p>
          <p className='text-4xl font-semibold md:py-2 md:text-6xl' >Shubham</p>
          {/* <p className='text-xl md:text-3xl ' >front-end Developer</p> */}
          <div className='inline text-xl md:text-3xl'>
          <Typewriter
            options={{
              strings: ['Web Developer', 'Digital Marketer', 'Video editor'],
              autoStart: true,
              loop: true,
            }}
          />
          </div>
          
        </div>
      </div>
      {/* right box */}
      <div className="h-[auto] flex flex-wrap justify-center items-start md:h-full md:w-[50%] md:justify-start md:items-center">
        <Tilt className='h-auto p-8'>
          <img src={hero} alt="hero" loading='lazy' className='h-[18rem] md:h-auto w-[90%] mx-auto md:m-0 shadow-2xl shadow-blue' />
        </Tilt>
      </div>
    </div>
  )
}

export default withScrollReveal(Home);